// Libs
import classNames from 'classnames/bind';
import { Box } from '@mui/material';
import { useFormContext, useWatch } from 'react-hook-form';
import { useParams } from 'react-router-dom';
// Components, Layouts, Pages
import { EstimateDocumentTemplate } from '~/pages/template';
import { DocumentLocal } from '~/components/module/document';
// Others
import { IFolderLocal } from '~/utils/interface/document';
import { IFormEstimate, IPhotoAttachmentEstimate } from '~/utils/interface/estimate';
import { BusinessTypeEnum } from '~/utils/enum/common';
// Styles, images, icons
import styles from './CreateEstimateAttachment.module.scss';

type Props = {};

const cx = classNames.bind(styles);

const CreateEstimateAttachment = (props: Props) => {
  //#region Destructuring Props

  //#endregion Destructuring Props

  //#region Declare Hook
  const { id: estimateId } = useParams();
  const { control, setValue } = useFormContext<IFormEstimate>();
  const folders = useWatch({ control, name: 'folders' });
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  const handleChange = (data: IFolderLocal[]) => {
    const formatData: IPhotoAttachmentEstimate[] = data.map((folder) => {
      return {
        name: folder.name,
        isCurrentApply: folder.isCurrentApply,
        files: folder?.files?.map((file) => {
          return {
            url: file.url,
            fieldName: file.fieldName,
            size: file.size,
            mimetype: file.mimetype,
            name: file.name,
          };
        }),
      };
    });
    setValue('folders', formatData, { shouldDirty: true });
  };
  //#endregion Handle Function

  return (
    <Box component={'div'} id='createEstimateAttachment' className={cx('container')}>
      {estimateId ? (
        <EstimateDocumentTemplate />
      ) : (
        <DocumentLocal
          id={estimateId}
          folders={folders}
          onChange={handleChange}
          businessType={BusinessTypeEnum.ESTIMATE}
        />
      )}
    </Box>
  );
};

export default CreateEstimateAttachment;
